import {} from "vue";
import { ref } from "vue";
let toastRef = ref(null);
export const setToastComponentRef = (newRef) => {
    // eslint-disable-next-line vue/no-ref-as-operand
    toastRef = newRef;
};
/**
 * Direct export to simplify usage in Options Api component.
 * Use 'useToast' for the Composition Api instead.
 */
export const Toast = {
    success(message, title = "Success", href = "") {
        var _a;
        (_a = toastRef.value) === null || _a === void 0 ? void 0 : _a.showToast(message, title, "success", href);
    },
    info(message, title = "Info", href = "") {
        var _a;
        (_a = toastRef.value) === null || _a === void 0 ? void 0 : _a.showToast(message, title, "info", href);
    },
    warning(message, title = "Warning", href = "") {
        var _a;
        (_a = toastRef.value) === null || _a === void 0 ? void 0 : _a.showToast(message, title, "warning", href);
    },
    error(message, title = "Error", href = "") {
        var _a;
        (_a = toastRef.value) === null || _a === void 0 ? void 0 : _a.showToast(message, title, "danger", href);
    },
};
export function useToast() {
    return Object.assign({}, Toast);
}
